import { Box } from '@mui/material';
import { Bullet, PoolTypography } from '@synergy/components';
import { Component } from 'react';
import { FormikProps } from 'formik';

import { ConvertReceiptCustomerSupplier } from './convert-receipt-customer-supplier';
import { ConvertReceiptLocked } from './convert-receipt-locked';
import { ConverterCustomer } from '../models/internal/converter-customer';
import { ConverterJob } from '../models/internal/converterJob';

interface ConvertReceiptCustomerProps {
    showCustomer?: boolean;
    showCustomerAsHeader?: boolean;
    converterCustomer: ConverterCustomer;
    converterCustomerIndex: number;
    formikProps: FormikProps<ConverterJob>;
    showPrice: boolean;
    showDiscount: boolean;
    showTax: boolean;
    showDeliveryCosts: boolean;
}
export const ConvertReceiptCustomer = class ConvertReceiptCustomerBase extends Component<ConvertReceiptCustomerProps> {
    public static defaultProps: Partial<ConvertReceiptCustomerProps> = {
        showCustomer: true,
        showCustomerAsHeader: false,
    };

    public render() {
        const {
            converterCustomer,
            converterCustomerIndex,
            showCustomer,
            showCustomerAsHeader,
            showPrice,
            showTax,
            showDiscount,
            showDeliveryCosts,
            formikProps,
        } = this.props;

        const customerSuppliers = converterCustomer.customerSuppliers || [];

        return (
            <div>
                {(showCustomer || showCustomerAsHeader) && (
                    <PoolTypography styleType="sectionTitle">
                        {converterCustomer.name}
                        <Bullet />
                        {converterCustomer.deliveryAddress.title && (
                            <>
                                {converterCustomer.deliveryAddress.title} <Bullet />
                            </>
                        )}
                        {[
                            converterCustomer.deliveryAddress.street,
                            converterCustomer.deliveryAddress.number,
                            converterCustomer.deliveryAddress.addition,
                        ]
                            .filter(Boolean)
                            .join(' ')}
                        <Bullet />
                        {converterCustomer.deliveryAddress.city}
                    </PoolTypography>
                )}
                {showCustomerAsHeader && converterCustomer.customerContact?.fullName && (
                    <Box sx={{ mb: 1 }}>
                        <PoolTypography typography="body1">
                            <strong>{converterCustomer.customerContact?.fullName}</strong>
                        </PoolTypography>
                    </Box>
                )}
                {converterCustomer.isLocked && <ConvertReceiptLocked name={converterCustomer.name} role="customer" />}
                {customerSuppliers.map((supplier, index) => (
                    <ConvertReceiptCustomerSupplier
                        key={supplier.id}
                        converterSupplier={supplier}
                        convertCustomer={converterCustomer}
                        converterCustomerIndex={converterCustomerIndex}
                        converterSupplierIndex={index}
                        locked={converterCustomer.isLocked}
                        formikProps={formikProps}
                        showPrice={showPrice}
                        showDiscount={showDiscount}
                        showTax={showTax}
                        showDeliveryCosts={showDeliveryCosts}
                    />
                ))}
            </div>
        );
    }
};
